module.exports = __webpack_public_path__ + "assets/img/20c57f459f3ae68d8e8312bf24edee03.svg";